import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceDTO, InsuranceType } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

interface Props {
  label?: string;
  insuranceType: InsuranceType;
  data: InsuranceDTO;
  setAlert?: (message: string) => void;
}

export const AccountOwnerSelect = ({
  label = 'Account Owner',
  insuranceType,
  data,
  setAlert,
}: Props) => {
  const formBag = useFormContext<FormFields>();

  const beneficiaries = formBag.watch('AccountBeneficiaries.Beneficiaries');

  const options = Object.keys(data.Options.InsuranceOwnerOptions)
    .filter(key => {
      if (key === 'Trusts') {
        return insuranceType === InsuranceType.Life;
      }

      return true;
    })
    .map(key => ({
      label: key,
      options: (data.Options.InsuranceOwnerOptions[key] || []).map(name => ({
        label: name,
        value: name,
      })) as { label: string; value: string }[],
    }));

  return (
    <Controller
      control={formBag.control}
      name="AccountOwner"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label={label}
            value={value ? { value, label: value } : null}
            options={options}
            onChange={opt => {
              onChange(opt?.value);

              if (setAlert) {
                if (beneficiaries.length > 0 || opt?.value === 'Trust') {
                  setAlert(
                    "Changing account ownership of this account will result in the trust's beneficiary designations superseding the existing account beneficiaries.",
                  );

                  formBag.setValue('AccountBeneficiaries.Beneficiaries', []);
                }
              }
            }}
            isPortal
          />
        );
      }}
    />
  );
};
